import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, ListSection, ListItem, CardVirtual } from 'medua-components';

/* eslint-disable */
@translate('account')
export default class AccountBilling extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:billing.title') }>
        <ListSection
          margin
          title={ this.props.t('account:billing.plans') }>
          <CardVirtual
            small
            logo
            style={{ display: 'inline-block', width: 'calc(50% - 15px)' }}
            title="School Basic"
            subtitle={ this.props.t('account:billing.free') }
            button={{ text: 'Active' }} />
          <CardVirtual
            small
            logo
            className="pro"
            style={{ display: 'inline-block', width: 'calc(50% - 15px)' }}
            title="School Pro"
            subtitle="Pay as you grow"
            button={{ text: 'Switch' }} />
        </ListSection>
        <ListItem
          duo
          key="1"
          title={ this.props.t('account:billing.payment-information.title') }
          subtitle={ 'Master Card ' + this.props.t('account:billing.payment-information.text') + ' 5897'}
          url="/account/billing/payment" />
        <ListItem
          duo
          key="2"
          title={ this.props.t('account:billing.history.title') }
          subtitle={ this.props.t('account:billing.history.text') + ' 19.02.2017' }
          url="/account/billing/history" />
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/billing/index.jsx